/*
 * Jira Ticket:
 * Created Date: Wed, 13th May 2020, 17:50:29 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import { getListRoles } from 'DataProvider/queries';

export const revokeEmploymentInviteMutation = gql`
  mutation RevokeEmploymentInvite($id: ID!) {
    data: revokeEmploymentInvite(id: $id) {
      success
    }
  }
`;

export default async ({ client, params }) => {
  try {
    const result = await client.mutate({
      mutation: revokeEmploymentInviteMutation,
      variables: {
        ...params,
      },
    });
    await getListRoles({ client, params });
    return result;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
